import React from 'react';
import {Image} from 'react-native';

export default function MobileEncryption({ width, height } : SvgProps) {
  return <Image style={{ width, height }} source={require('./undraw_mobile_encryption_re_yw3o.svg')} />
};

